module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/fFXtFl/tc-custom/9798886933703.jpg?1702083731119",
      "alt": "This image is the cover for the book The Sky Pilot&rsquo;s Wife"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Sky Pilot’s Wife\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', {
    staticStyle: {
      "margin-top": "0cm",
      "margin-right": "0cm",
      "margin-bottom": "8.0pt",
      "margin-left": "0cm",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif"
    }
  }, [_c('em', [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-family": "\"Arial Nova\",sans-serif"
    }
  }, [_vm._v("The Sky Pilot’s Wife")])]), _c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-family": "\"Arial Nova\",sans-serif"
    }
  }, [_vm._v(" is a historical romance and ‘slice of life’ novel set in the late Victorian period (1899-1902) in a quaint village on the Yorkshire Moors of England.")])]), _c('p', {
    staticStyle: {
      "margin": "0cm 0cm 8pt",
      "font-size": "15px",
      "font-family": "Calibri, sans-serif"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-family": "\"Arial Nova\",sans-serif"
    }
  }, [_vm._v("An intriguing romance arises between two of the most unlikely characters and it is heightened by the ‘secret language of flowers.’ The green-eyed monster, jealousy, causes an inevitable conflict and the rising tension creates a catastrophe which triggers a totally unexpected train of events.")])]), _c('p', {
    staticStyle: {
      "margin": "0cm 0cm 8pt",
      "font-size": "15px",
      "font-family": "Calibri, sans-serif"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-family": "\"Arial Nova\",sans-serif"
    }
  }, [_vm._v("Later, during a storm, the vicar’s wife, Louisa flees the vicarage to seek shelter within the confines of the church. But providence intervenes and gossip in the village becomes rife, much to Louisa’s consternation.")])]), _c('p', {
    staticStyle: {
      "margin": "0cm 0cm 8pt",
      "font-size": "15px",
      "font-family": "Calibri, sans-serif"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-family": "\"Arial Nova\",sans-serif"
    }
  }, [_vm._v("A fire later breaks out in the belltower of the church and the local constabulary is brought in to help solve the unfolding mystery. But who is it that wants Louisa dead? What is the purpose of this heinous crime? And who should pay?")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Christine Coleman\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', [_vm._v("Christine Coleman, a University of Auckland graduate, practiced optometry in both Australia and New Zealand. Her other accomplishments include being a violinist with the New Zealand National Youth Orchestra, a singer with the Hamilton Operatic Society, an actress with the Mairangi Players, as well as a creditable pianist and bagpiper. Christine is a prolific short story writer and lives in Auckland with her husband, Brian.")]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0